export const NftDefaultValue = [
  {
    id: 1,
    title: "Smiley #3",
    price: "30",
    img: "../../../assets/img/default/nft/1.jpg",
    owner: {
      id: 1,
      name: "Oxygen",
      wallet: "0x906782e3772B3a2267e3bce393B509E1d13859AA",
    },
    creator: {
      id: 1,
      name: "Cinematic",
      wallet: "0x9621d6c9417E95e257f9318288377a424C1EffEb",
    },
    collection: {
      id: 1,
      title: "KidzTokyo",
    },
  },
  {
    id: 2,
    title: "Jordan #2",
    price: "40",
    img: "../../../assets/img/default/collection/1.png",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
    collection: {
      id: 2,
      title: "Robotos NFT",
    },
  },
  {
    id: 3,
    title: "Darth Vader #3",
    price: "25",
    img: "../../../assets/img/default/nft/3.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
    collection: {
      id: 2,
      title: "Robotos NFT",
    },
  },
  {
    id: 4,
    title: "Smiley #4",
    price: "35",
    img: "../../../assets/img/default/nft/4.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
  },
  {
    id: 5,
    title: "Darth Vader #4",
    price: "325",
    img: "../../../assets/img/default/nft/5.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
  },
  {
    id: 6,
    title: "Smiley #2",
    price: "20",
    img: "../../../assets/img/default/nft/6.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
    collection: {
      id: 2,
      title: "Robotos NFT",
    },
  },
  {
    id: 7,
    title: "Darth Vader #1",
    price: "30",
    img: "../../../assets/img/default/nft/7.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
  },
  {
    id: 8,
    title: "Smiley #3",
    price: "30",
    img: "../../../assets/img/default/nft/8.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
  },
  {
    id: 9,
    title: "Jordan #4",
    price: "30",
    img: "../../../assets/img/default/nft/9.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
    collection: {
      id: 2,
      title: "Robotos NFT",
    },
  },
  {
    id: 10,
    title: "Jordan #1",
    price: "50",
    img: "../../../assets/img/default/nft/10.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
    collection: {
      id: 2,
      title: "Robotos NFT",
    },
  },
  {
    id: 11,
    title: "Darth Vader #2",
    price: "20",
    img: "../../../assets/img/default/nft/11.jpg",
  },
  {
    id: 12,
    title: "Jordan #3",
    price: "32",
    img: "../../../assets/img/default/nft/12.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
    collection: {
      id: 2,
      title: "Robotos NFT",
    },
  },
  {
    id: 13,
    title: "Smiley #1",
    price: "35",
    img: "../../../assets/img/default/nft/13.jpg",
    owner: {
      id: 2,
      name: "Doctor_Mundi",
      wallet: "0xD6914D5a931bE7e50d41429D03a7b5335818665d",
    },
    creator: {
      id: 3,
      name: "Superstar",
      wallet: "0x0B6791f6A7eEFBe6d70184D2CF4644b12C9BD3Be",
    },
  },
];
